module.exports = __webpack_public_path__ + "static/video_img-28ace89e3f15327bbc6d051da23c9188.png";